var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"answers_multichoice"},_vm._l((_vm.data),function(item){return _c('vchecklabel',{key:item.id,staticClass:"answer",attrs:{"value":_vm.selected_ids.indexOf(item.id) > -1,"label":item.body,"disabled":_vm.isDisabled},on:{"input":function($event){return _vm.set_selected_ids($event, item.id)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }